<template>
  <div class="herder-list">
    <img
      class="lang-black"
      @click="changeLang"
      v-if="false"
      src="@/assets/image/common/lang-black.png"
    />
    <div
      :class="['nav-item', { active: active === item.path }]"
      v-for="(item, index) in $t('home.mobileHerder2')"
      :key="index"
      @click="close(item.path)"
    >
      <div class="title">{{ item.name }}</div>

      <div
        v-if="item.children"
        v-for="(cItem, cIndex) in item.children"
        :key="cIndex"
      >
        <div class="c-title">{{ cItem.name }}</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  methods: {
    close(path) {
      if (path) {
        this.$router.push(path);
      }

      this.$emit("close");
    },
    changeLang() {
      return
      if (this.$i18n.locale === "zn") {
        // 判断当前语言
        this.$i18n.locale = "en"; // 设置当前语言
        localStorage.setItem("lang", "en");
      } else {
        this.$i18n.locale = "zn";
        localStorage.setItem("lang", "zn");
      }
    },
  },
  computed: {
    active() {
      return this.$route.path;
    },
  },
};
</script>
<style lang="scss" scoped>
.herder-list {
  display: none;
  position: fixed;
  width: 100%;
  background-color: #fff;
  overflow: auto;
  max-height: calc(100vh - 70px);
  top: 70px;
  .lang-black {
    width: 18px;
    height: 18px;
    margin-top: 16px;
    margin-bottom: 20px;
    cursor: pointer;
    position: relative;
    left: 50%;
    transform: translateX(-50%);
  }
  .nav-item {
    cursor: pointer;
    margin-bottom: 25px;
    .title {
      text-align: center;
      color: #232323;
      font-size: 16px;
      font-weight: bolder;
    }
    .c-title {
      text-align: center;
      color: #232323;
      font-size: 14px;
      margin-top: 22px;
    }
  }
  .active {
    .title {
      color: #8846ff;
    }
    .c-title {
      color: #8846ff;
    }
  }
  .nav-item:last-child {
    margin-bottom: 19px;
  }
}
</style>
<style lang="scss" scoped>
/* 媒体查询 */
@media only screen and (max-width: 1000px) {
  .herder-list {
    display: block;
  }
}
</style>